import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { MiniLayoutWrapperComponent } from '@uigy/shared/components/mini-layout-wrapper/mini-layout-wrapper.component';
import { NagService } from '@uigy/shared/components/nag/services/nag.service';
import { ToasterService } from '@uigy/shared/components/toaster/services/toaster.service';
import { ConfigResponse } from '@uigy/shared/models/interfaces';
import { ConfigService } from '@uigy/shared/services/config.service';
import { IemService } from '@uigy/shared/services/iem.service';
import { LanguageService } from '@uigy/shared/services/language.service';
import { LoaderComponent } from '@uigy/shared/components/loader/loader.component';
import { Observable, of } from 'rxjs';
import { catchError, first, map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-reboot',
  templateUrl: './reboot.component.html',
  imports: [
    MiniLayoutWrapperComponent,
    LoaderComponent,
    NgIf,
    AsyncPipe,
    NgForOf,
  ],
})
export class RebootComponent implements OnInit {
  public readonly rebootTexts = this.languageService.texts.mini_layout_pages.reboot;
  public readonly availableIpTexts = this.languageService.texts.mini_layout_pages.available_ip;

  public readonly ip$: Observable<string[] | null | undefined> = this.route.queryParamMap.pipe(
    first(),
    switchMap((params: ParamMap): Observable<string[] | null | undefined> => {
      return params.has('ip') ? of([params.get('ip') ?? '']) : this.configService.fetchConfig(false, true).pipe(
        map((config: ConfigResponse): string[] | undefined => {
          const ipAddress = config.MgmtServiceNetworkConfig?.Value.interfaceIpConfigurations[0]?.ipAddress;
          const hosts = config.UIHosts?.Value;

          if (hosts && hosts.length > 0) {
            return hosts.concat(ipAddress);
          }
          return [ipAddress];
        }),
        catchError(() => of(null)),
      );
    }),
  );

  constructor(private languageService: LanguageService,
              private configService: ConfigService,
              private route: ActivatedRoute,
              private nagService: NagService,
              private toasterService: ToasterService,
              public iemService: IemService,
  ) {
  }

  public ngOnInit(): void {
    this.nagService.clear();
    this.toasterService.clear();
  }
}
